let Intro = Vue.component('intro', {
	computed: {
		introDone() {
			return this.$store.state.loopHelper.introAnimation
		},
		introClasses: function() {
			return {
				'pixel-intro--hidden': !this.$store.state.loopHelper.isIntro
			}
		},
		backgroundClasses: function() {
			return {
				'background--hidden': !this.$store.state.loopHelper.isIntro
			}
		}
	},
	template: `
		<div v-if="!introDone">
			<div class="pixel-intro" :class="introClasses"></div>
			<div class="background" :class="backgroundClasses"></div>
		</div>`
})

export default Intro
